const getDummyAvatar = () => {
    const id=Math.floor(Math.random() * 30);
    return 'https://i.pravatar.cc/300?img='+id
}
export { getDummyAvatar }